import { Workbox } from 'workbox-window';
import { store } from './app/stores/store';

export function register() {
  // Enable service worker in both development and production
  if ('serviceWorker' in navigator && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development')) {
    const wb = new Workbox(`${process.env.PUBLIC_URL}/service-worker.js`);

    // 1. Add an event listener to detect when the registered service worker has installed but is waiting to activate.
    wb.addEventListener('waiting', (event) => {
      store.commonStore.setUpdateAvailable(true);
      store.commonStore.setWorkbox(wb);
    });

    // 2. Add an event listener to detect when the service worker controls the page.
    wb.addEventListener('controlling', (event) => {
      // If this is not the first service worker, reload.
      // event.isUpdate is true if the service worker was updated.
      // But usually just checking if we had a controller before is safer or just simply reload
      // to ensure all assets are fresh.
      window.location.reload();
    });

    // 3. Register the service worker
    wb.register();

    // 4. Optimization: Check for updates when the window regains focus
    // This allows the app to self-update if it's been left open in the background.
    const checkForUpdate = async () => {
        try {
            await wb.update();
        } catch (error) {
            console.error('Error checking for updates:', error);
        }
    };

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            checkForUpdate();
        }
    });
  }
}
